import styled from "styled-components"

export const TimerDisplay = styled.div`
  display: inline-block;
  color: ${props => (props.timeout ? "#d0051E" : "#72C912")};
`
